var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 35,
    height: 22,
    viewBox: "0 0 35 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35,4L35,22L34.982,20.8537C34.9572,19.2704,33.6667,18,32.0833,18L4,18C1.79086,18,0,16.2091,0,14L0,4C0,1.79086,1.79086,0,4,0L31,0C33.2091,0,35,1.79086,35,4Z",
    fillRule: "evenodd",
    fill: "#11C993",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,-0.10492528975009918,0.9944801330566406,0.20985057950019836,0.01103973388671875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.26,13L12.95,13L12.95,6L11.33,6L11.33,11.53L11.2,11.53L9.53,6L6.9,6L6.9,13L8.52,13L8.52,7.56L8.58,7.56L10.26,13ZM14.15,13L19.07,13L19.07,11.64L15.8,11.64L15.8,10.13L18.64,10.13L18.64,8.86L15.8,8.86L15.8,7.36L19.07,7.36L19.07,6L14.15,6L14.15,13ZM24.84,13L26.85,13L28.55,6L26.83,6L25.83,11.28L25.79,11.28L24.79,6L23.28,6L22.28,11.28L22.24,11.28L21.240000000000002,6L19.52,6L21.22,13L23.23,13L24.02,8.469999999999999L24.06,8.469999999999999L24.84,13Z",
    fill: "#FFFFFF",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "media/NewIcon.007a4648.svg";
export { ForwardRef as ReactComponent };